export const URL_API = 'https://api.uberaccounting.vn';
// export const URL_API = 'http://194.233.94.240:9001';
// export const URL_API = 'http://localhost:10001';
export const URL_IMG_PUB = URL_API + "/api/one-book-resource/public/show-avatar/"
// export const URL_API select-plan-step-1= 'http://61.14.237.86:9001';